import { ActionsObservable, combineEpics, StateObservable } from 'redux-observable'
import { Deps, State } from 'src/app.store'
import { DSService } from 'src/services/ds.service'
import { filter, mergeMap } from 'rxjs/operators'
import { from } from 'rxjs'
import { notification } from 'antd'
import {
  SaveTest,
  SelectTest,
  updateTestActions,
  UpdateTestActions
} from 'src/tests-components/update-test/update-test.actions'
import { genericError } from 'src/utils/notifications.utils'
import { pipe } from 'fp-ts/lib/pipeable'
import * as O from 'fp-ts/lib/Option'

interface Action$ extends ActionsObservable<UpdateTestActions> {}
interface State$ extends StateObservable<State> {}

const loadTest = (dsService: DSService) => (p: SelectTest) =>
  from(
    dsService
      .getTestInfos(p.testName)
      .map(resOpt =>
        pipe(
          resOpt,
          O.fold(
            () => updateTestActions.UpdateTestLoadTestFailure({ testName: p.testName }),
            res => updateTestActions.UpdateTestLoadTestSuccess({ test: res.result })
          )
        )
      )
  )

const saveTest = (dsService: DSService) => (p: SaveTest) =>
  from(
    dsService.setTestInfos(p.test, p.test.id).map(resOpt =>
      pipe(
        resOpt,
        O.fold(
          () => {
            genericError()
            return updateTestActions.UpdateTestSaveTestFailure({ test: p.test })
          },
          _res => {
            notification.success({
              description: 'Le test a bien été mis à jour',
              message: 'Test mis à jour'
            })
            return updateTestActions.UpdateTestSaveTestSuccess({ test: p.test })
          }
        )
      )
    )
  )

export const loadTestEpic = (action$: Action$, _: State$, deps: Deps) =>
  action$.pipe(
    filter(updateTestActions.is.UpdateTestSelectTest),
    mergeMap(loadTest(deps.dsService))
  )

export const saveTestEpic = (action$: Action$, _: State$, deps: Deps) =>
  action$.pipe(
    filter(updateTestActions.is.UpdateTestSaveTest),
    mergeMap(saveTest(deps.dsService))
  )

export const updateTestEpics = combineEpics(loadTestEpic, saveTestEpic)



// WEBPACK FOOTER //
// ./src/tests-components/update-test/update-test.epics.ts